import { Controller } from "@hotwired/stimulus"
import { Dropdown } from 'foundation-sites'
import $ from 'jquery'

/*
// if $parent appeared after initialization, search for it (eg datatales)
class DD extends Dropdown {
  open() {
    if(this.options.parentClass && !this.$parent) {
      this.$parent = this.$element.parents(`.${this.options.parentClass}`)
    }

    super.open()
  }
}
*/

export default class extends Controller {
  static ddContainer() {
    let container = document.getElementById('dd-container')
    if(!container) {
      container = document.createElement('div')
      container.id = 'dd-container'
      document.body.appendChild(container)
    }
    return container
  }

  static values = {
    parentClass: String,
    hoverDelay: Number,
    hover: Boolean,
    hoverPane: Boolean,
    vOffset: Number,
    hOffset: Number,
    position: String,
    alignment: String,
    allowOverlap: Boolean,
    allowBottomOverlap: Boolean,
    trapFocus: Boolean,
    autoFocus: Boolean,	
    closeOnClick: Boolean,
    forceFollow: Boolean
  }

  #ddHtml = null
  #ddElement = null
  #dropdown = null
  #cleanupTimeout = null
  #proxies = []

  connect() {
    const ddId = this.element.dataset.toggle
    const parent = this.element.parentElement;
    if(this.#cleanupTimeout) {
      clearTimeout(this.#cleanupTimeout)
      this.#cleanupTimeout = null
    }

    if(!this.#ddHtml) {
      const ddElement = document.getElementById(ddId)
      if(!ddElement) {
        console.error('dropdown not found', ddId)
        return
      }
      this.#ddHtml = ddElement.outerHTML
      ddElement.remove()
    }
    if(!this.#ddElement) {
      this.#ddElement = this.#createElement(this.#ddHtml)
      this.constructor.ddContainer().appendChild(this.#ddElement)
      this.#dropdown = new Dropdown($(this.#ddElement), this.options)

      this.#ddElement.querySelectorAll('a[data-action]')?.forEach(link => {
        const events = this.#parseEvents(link.dataset.action)
        link.addEventListener('click', () => this.#dropdown.close())
        events.forEach(descriptor => {
          const options = {}
          if(typeof descriptor.capture !== 'undefined') options.capture = descriptor.capture
          if(typeof descriptor.once !== 'undefined') options.once = descriptor.once
          if(typeof descriptor.passive !== 'undefined') options.passive = descriptor.passive
                    
          link.addEventListener(descriptor.event, (event) => { 
            if(descriptor.preventDefault) event.preventDefault()
            if(descriptor.stopPropagation) event.stopPropagation()
            const el = parent.closest(`[data-controller="${descriptor.controller}"]`)
            if(el) {
              const controller = this.application.getControllerForElementAndIdentifier(el, descriptor.controller)
              const params = this.#extractParamsFor(link, descriptor.controller)
              event.params = params
              controller[descriptor.callback](event)
            }
          }, options)
        })
      })
    }
    this.dispatch('connect')
  }

  get dropdown() {
    return this.#ddElement
  }

  disconnect() {
    // remove the dropdown after 500ms
    // prevent adding and removing the dropdown multiple times eg on datatable re-render
    this.#cleanupTimeout = setTimeout(() => {
      this.#cleanup()
    }, 500)
  }

  #cleanup() {
    this.#dropdown.destroy()
    this.#ddElement.remove()
    this.#ddElement = null
  }

  get options() {
    const options = {
      closeOnClick: true,
      allowOverlap: false,
      allowBottomOverlap: false,
    }
    if(this.hasParentClassValue) options.parentClass = this.parentClassValue
    if(this.hasHoverDelayValue) options.hoverDelay = this.hoverDelayValue
    if(this.hasHoverValue) options.hover = this.hoverValue
    if(this.hasHoverPaneValue) options.hoverPane = this.hoverPaneValue
    if(this.hasVOffsetValue) options.vOffset = this.vOffsetValue
    if(this.hasHOffsetValue) options.hOffset = this.hOffsetValue
    if(this.hasPositionValue) options.position = this.positionValue
    if(this.hasAlignmentValue) options.alignment = this.alignmentValue
    if(this.hasAllowOverlapValue) options.allowOverlap = this.allowOverlapValue
    if(this.hasAllowBottomOverlapValue) options.allowBottomOverlap = this.allowBottomOverlapValue
    if(this.hasTrapFocusValue) options.trapFocus = this.trapFocusValue
    if(this.hasAutoFocusValue) options.autoFocus = this.autoFocusValue
    if(this.hasCloseOnClickValue) options.closeOnClick = this.closeOnClickValue
    if(this.hasForceFollowValue) options.forceFollow = this.forceFollowValue
    return options
  }

  #createElement(html) {
    const tpl = document.createElement('template')
    tpl.innerHTML = html
    const dd = tpl.content.firstElementChild
    return dd
  }

  #parseEvents(actions) {
    const events = []
    actions.split(' ').forEach(action => {
      action = action.trim()
      let [event, target] = action.split('->')
      let global, modifier;
      [event, global] = event.split('@')
      if(!target) {
        target = event
        event = 'click'
      }
      [target, modifier] = target.split(':')
      const [controller, callback] = target.split('#')
  
      const ev = {event, global, controller, callback, modifier}
      switch(modifier) {
        case 'prevent':
          ev.preventDefault = true
          break
        case 'stop':
          ev.stopPropagation = true
          break
        case 'capture':
          ev.capture = true
          break
        case 'once':
          ev.stopPropagation = true
          break
        case 'passive':
          ev.passive = true
          break
        case '!passive':
          ev.passive = false
          break
      }
      events.push(ev)
    })
    return events
  }

  #extractParamsFor(link, controller) {
    controller = this.#dashToCamel(controller)
    const rex = new RegExp(`^${controller}(.+)Param$`)
    const params = {}
    const data = link.dataset
    Object.keys(data).forEach(key => {
      const match = key.match(rex)
      if(match) {
        let param = match[1]
        param = param.charAt(0).toLowerCase() + param.slice(1)
        try {
          params[param] = JSON.parse(data[key])
        } catch(e) {
          params[param] = data[key]
        }
      }
    })
    return params
  }

  #dashToCamel(str) {
    return str.toLowerCase().replace(/-([a-z])/g, (match, letter) => letter.toUpperCase())
  }
}

